import { render } from "./FinMenu.vue?vue&type=template&id=0ecf62f0"
import script from "./FinMenu.vue?vue&type=script&lang=js"
export * from "./FinMenu.vue?vue&type=script&lang=js"

import exportComponent from "G:\\Projeto_ELITE\\VUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__